import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/auth-context';
import { NotistackProvider, EnvBadge } from './components/shared';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';

//Provider & store
import { Provider } from 'react-redux';
import { store } from './redux/store';

// Adjunta el JWT a toda llamada axios/fetch y cierra sesión ante un 401.
// Debe instalarse antes del primer render.
import { installHttpInterceptors } from './lib/http';
installHttpInterceptors();

serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <AuthProvider>
          <NotistackProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </NotistackProvider>
        </AuthProvider>
      </Provider>
      {/* Fuera de <App /> a proposito: asi el sello de entorno cubre los tres
          armazones —dashboard, portal de directores y paginas publicas— sin
          tener que tocar cada uno. */}
      <EnvBadge />
    </ThemeProvider>
  </React.StrictMode>,
);
